var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-4"},[_c('preriod-input'),_c('branch-tabs'),_c('div',{staticClass:"w-100 text-center py-2"},[_c('b-btn',{on:{"click":_vm.calculate}},[_vm._v(" Обчислити ")])],1),_c('result',{staticClass:"mt-4"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }